import {rootState} from '@mintdata-wsp/common/state/RootState';
import {ConfigUtil} from '@mintdata-wsp/common/util/ConfigUtil';
import {WindowLocationUtil} from '@mintdata-wsp/common/util/WindowLocationUtil';
import {autorun} from 'mobx';
import {AnalyticsEventActions} from '@mintdata-wsp/common/controllers/analytics/AnalyticsEventActions';

declare let call2_args:any;
declare let call2:any;
declare let MIXPANEL_CUSTOM_LIB_URL:any;
declare let window:any;
declare let mixpanel:any;

export class MixpanelController
{
    private _isInitialized:boolean = false;

    public init():void
    {
        if( this.isInitialized() )
            return;

        // below is a code snipped copied from mixpanel
        (function(f,b){if(!b.__SV){var e,g,i,h;window.mixpanel=b;b._i=[];b.init=function(e,f,c){function g(a,d){var b=d.split(".");2==b.length&&(a=a[b[0]],d=b[1]);a[d]=function(){a.push([d].concat(Array.prototype.slice.call(arguments,0)))}}var a=b;"undefined"!==typeof c?a=b[c]=[]:c="mixpanel";a.people=a.people||[];a.toString=function(a){var d="mixpanel";"mixpanel"!==c&&(d+="."+c);a||(d+=" (stub)");return d};a.people.toString=function(){return a.toString(1)+".people (stub)"};i="disable time_event track track_pageview track_links track_forms track_with_groups add_group set_group remove_group register register_once alias unregister identify name_tag set_config reset opt_in_tracking opt_out_tracking has_opted_in_tracking has_opted_out_tracking clear_opt_in_out_tracking start_batch_senders people.set people.set_once people.unset people.increment people.append people.union people.track_charge people.clear_charges people.delete_user people.remove".split(" ");
for(h=0;h<i.length;h++)g(a,i[h]);var j="set set_once union unset remove delete".split(" ");a.get_group=function(){function b(c){d[c]=function(){call2_args=arguments;call2=[c].concat(Array.prototype.slice.call(call2_args,0));a.push([e,call2])}}for(var d={},e=["get_group"].concat(Array.prototype.slice.call(arguments,0)),c=0;c<j.length;c++)b(j[c]);return d};b._i.push([e,f,c])};b.__SV=1.2;e=f.createElement("script");e.type="text/javascript";e.async=!0;e.src="undefined"!==typeof MIXPANEL_CUSTOM_LIB_URL?
MIXPANEL_CUSTOM_LIB_URL:"file:"===f.location.protocol&&"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js".match(/^\/\//)?"https://cdn.mxpnl.com/libs/mixpanel-2-latest.min.js":"//cdn.mxpnl.com/libs/mixpanel-2-latest.min.js";g=f.getElementsByTagName("script")[0];g.parentNode.insertBefore(e,g)}})(document,window.mixpanel||[]);

        // 2214870a04f1cf3ad3790758b16f73c2
        mixpanel.init(ConfigUtil.mixpanelProjectToken());

        autorun(() =>
        {
            if( rootState.userSession && rootState.userSession.currentUser && rootState.userSession.currentUser.id)
            {
                (window as any).mixpanel.identify(rootState.userSession.currentUser.id);
                this.sendProfileDetails();
            }
        });

        this._isInitialized = true;
    }

    public isInitialized():boolean
    {
        return this._isInitialized && (window as any).mixpanel;
    }

    public sendProfileDetails()
    {
        const user = rootState.userSession.currentUser;
        const organization = rootState.userSession.currentOrganization;

        (window as any).mixpanel.people.set({
            '$avatar': user.avatarUrl,
            'USER_ID': user.id,
            '$email': user.email,
            '$name': user.fullName,
            'Organization name': organization.name,
            'Organization SID': organization.siteId,
            'Hostname': WindowLocationUtil.getHostname(),
        });
    }

    public track(event:AnalyticsEventActions, value:any)
    {
        if( this.isInitialized() )
            (window as any).mixpanel.track(event, value);
    }
}
